<template>
  <el-dialog
    title="用户信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      size="small"
    >
      <el-form-item
        prop="name"
        label="账号"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item
        prop="trueName"
        label="用户名称"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.trueName"></el-input>
      </el-form-item>
      <el-form-item v-if="passwordEdit"
              prop="password"
              label="密码"
                    :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.password"> </el-input>
      </el-form-item>
      <el-form-item
        prop="email"
        label="邮箱"
      >
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item
        prop="phone"
        label="phone"
      >
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as userService from '@/api/sys/user'
import util from '@/libs/util.js'
export default {
  name: 'userEditForm',
  props: {
    user: Object,
    value: Boolean
  },
  data () {
    return {
      formEdit: true,
      passwordEdit: true,
      loading: false,
      dialogVisible: false,
      form: {
        name: '',
        trueName: '',
        phone: '',
        password: '',
        email: ''
      }
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.$refs.form.resetFields()
      if (this.user.userId) {
        // userService.getUser(this.user.id).then(data => {
        let form = {}
        form.name = this.user.userCode
        form.trueName = this.user.userName
        form.phone = this.user.mobileNo
        form.email = this.user.email
        this.form = form
        // });
        this.passwordEdit = false
        this.formEdit = true
      } else {
        this.passwordEdit = true
        this.formEdit = true
        this.form = {}
      }
    },
    checkUserCode () {
      console.log('=========checkUserCode:' + this.form.name)
      userService
        .getCheckUser({ userCode: this.form.name, id: this.user.userId })
        .then(data => {
          if (data == 'false') {
            this.$message('该账号已存在,请更换账号试试')
            this.formEdit = true
            this.form.name = ''
          } else {
            this.formEdit = true
          }
        })
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          userService
            .getCheckUser({ userCode: this.form.name, id: this.user.userId })
            .then(data2 => {
              console.log('=========data2:' + data2)
              if (data2 == 'true') {
                this.loading = true
                userService
                  .saveUser({ ...this.form, id: this.user.userId, xt_id: util.cookies.get('xt_id'), agentid: util.cookies.get('agentid') })
                  .then(data => {
                    this.loading = false
                    this.dialogVisible = false
                    this.$emit('submit')
                  })
              } else {
                this.$message('该账号已存在,请更换账号试试')
              }
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
